<header class="header">
  <div class="row">
    <div class="col">
      <h1 class="title">{{todayDay}}</h1>
      <h2 class="subtitle">{{todayDate}}</h2>
    </div>

    <div class="col-auto">
      <nav class="nav nav-header">
        <ul>
          <li><a class="link" routerLink="todo" routerLinkActive="link-active">
            <i class="fas fa-tasks"></i></a></li>
          <li><a class="link" routerLink="settings" routerLinkActive="link-active">
            <i class="fas fa-cog"></i></a></li>
        </ul>
      </nav>
    </div>
  </div>
</header>
